type CloneOptions = {
    /** Scales the output canvas by this factor. */
    scale?: number;
};

export function cloneCanvas(sourceCanvas: HTMLCanvasElement, options?: CloneOptions): HTMLCanvasElement {
    const { scale = 1 } = options || {};
    const outputCanvas = document.createElement('canvas');
    outputCanvas.width = sourceCanvas.width * scale;
    outputCanvas.height = sourceCanvas.height * scale;

    const outputContext = outputCanvas.getContext('2d')!;
    outputContext.scale(scale, scale);
    outputContext.drawImage(sourceCanvas, 0, 0);
    outputContext.resetTransform();

    return outputCanvas;
}
